module.exports = __webpack_public_path__ + "img/V-63-ER-1500-BE.e949854f.png";